const YOUTUBE_API_KEY = "AIzaSyCSZ0bp-8JcGOTBBIKPuZ2Ok7MDlAt5Svk";
const FIREBASE_API_KEY = "AIzaSyBlGuqLxqbkNEiLcXqF-NdmBbd3SxDxTVo";
const FIREBASE_messagingSenderId = "435694800090";
const FIREBASE_appId = "1:435694800090:web:5a26591707bcee2113e9e3";
const FIREBASE_projectId = "aircheats-c0134";
const FIREBASE_authDomain = "aircheats-c0134.firebaseapp.com";
const FIREBASE_storageBucket = "aircheats-c0134.appspot.com";
const IMGUR_CLIENT_ID = "573f2d79c8c0fd0";
export {
  YOUTUBE_API_KEY,
  FIREBASE_API_KEY,
  FIREBASE_appId,
  FIREBASE_messagingSenderId,
  FIREBASE_authDomain,
  FIREBASE_projectId,
  FIREBASE_storageBucket,
  IMGUR_CLIENT_ID,
};
